import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import Seo from "@/components/Seo";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refreshArtworks, setCheckoutOpen, cart } = useStore();
  const { t } = useLang();
  const navigate = useNavigate();
  const retry = () => (cart.length ? setCheckoutOpen(true) : navigate("/shop"));

  useEffect(() => {
    if (sessionId) api.post(`/payments/cancel/${sessionId}`).catch(() => {}).finally(refreshArtworks);
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="payment-cancel-page" className="mx-auto max-w-2xl px-6 pb-28 pt-36 sm:px-10">
      <Seo title={t("payment.cancelTitle")} description={t("seo.home")} />
      <div className="border border-bone/10 bg-ink-2 p-10 text-center">
        <p className="font-mono text-[10px] tracking-[0.35em] text-brass">{t("payment.cancelTitle")}</p>
        <p className="mt-4 text-sm text-bone-dim">{t("payment.cancelNote")}</p>
        <div className="mt-8 flex justify-center gap-4">
          <button data-testid="payment-retry" onClick={retry} className="border border-brass/60 bg-brass/10 px-6 py-3 font-mono text-[10px] tracking-[0.3em] text-brass transition-all hover:bg-brass hover:text-ink">
            {t("payment.retry")}
          </button>
          <Link data-testid="payment-cancel-back-shop" to="/shop" className="border border-bone/20 px-6 py-3 font-mono text-[10px] tracking-[0.3em] text-bone transition-colors hover:border-brass/60 hover:text-brass">
            {t("payment.backShop")}
          </Link>
        </div>
      </div>
    </div>
  );
}
